import React from 'react';
import { ListChecks } from 'lucide-react';
import { ProjectMeetings } from '../../Meetings';
import TalkingPointsPanel from '../../Home/TalkingPointsPanel';
import ProjectLexicon from '../../ProjectDetail/ProjectLexicon';
import { Card } from '../ui';

// Réunions du projet ; à droite sur grand écran, les points à aborder avec le client et le lexique des transcriptions.
const MeetingsTab = ({ projectId, project }) => (
  <div className="grid grid-cols-1 items-start gap-4 xl:grid-cols-[minmax(0,1.6fr)_minmax(0,1fr)]">
    <Card>
      <ProjectMeetings projectId={projectId} />
    </Card>
    <div className="min-w-0 space-y-4">
      <Card title="Points à aborder avec le client" icon={ListChecks}>
        <TalkingPointsPanel projectId={Number(projectId)} meetingTitle={project?.name} />
      </Card>
      <Card>
        <ProjectLexicon projectId={Number(projectId)} />
      </Card>
    </div>
  </div>
);

export default MeetingsTab;
